import React, { useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import {
  ModalContainer,
  ModalHeader,
  ModalTitle,
  CloseButton,
  FormGroup,
  FormLabel,
  FormInput,
  FormSelect,
  FormTextarea,
  FormCheckboxGroup,
  FilterCheckbox,
  SkillsInput,
  FormActions,
  CancelButton,
  SubmitButton
} from '../../../../styles/components/JobPostManagement';

const JobPostForm = ({ 
  postData,
  isEdit,
  onSubmit,
  onCancel
}) => {
  const [formData, setFormData] = useState(postData || {
    title: '',
    duration: '',
    paid: false,
    salary: '',
    location: '',
    skills: [],
    description: '',
    status: 'pending'
  });
  
  const [skillInput, setSkillInput] = useState('');
  
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };
  
  const handleSkillInputChange = (e) => {
    setSkillInput(e.target.value);
  };
  
  const handleSkillInputKeyPress = (e) => {
    if (e.key === 'Enter' && skillInput.trim()) {
      e.preventDefault();
      if (!formData.skills.includes(skillInput.trim())) {
        setFormData({
          ...formData,
          skills: [...formData.skills, skillInput.trim()]
        });
      }
      setSkillInput('');
    }
  };
  
  const removeSkill = (skillToRemove) => {
    setFormData({
      ...formData,
      skills: formData.skills.filter(skill => skill !== skillToRemove)
    });
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };
  
  return (
    <ModalContainer>
      <ModalHeader>
        <ModalTitle>{isEdit ? 'Edit Job Post' : 'Create New Job Post'}</ModalTitle>
        <CloseButton onClick={onCancel}>
          <FaTimes />
        </CloseButton>
      </ModalHeader>
      
      <form onSubmit={handleSubmit}>
        <FormGroup>
          <FormLabel htmlFor="title">Job Title</FormLabel>
          <FormInput
            type="text"
            id="title"
            name="title"
            value={formData.title}
            onChange={handleInputChange}
            placeholder="e.g. Frontend Developer Intern"
            required
          />
        </FormGroup>
        
        <FormGroup>
          <FormLabel htmlFor="duration">Duration</FormLabel>
          <FormInput
            type="text"
            id="duration"
            name="duration"
            value={formData.duration}
            onChange={handleInputChange}
            placeholder="e.g. 3 months"
            required
          />
        </FormGroup>
        
        <FormGroup>
          <FormCheckboxGroup>
            <FilterCheckbox
              type="checkbox"
              id="paid"
              name="paid"
              checked={formData.paid}
              onChange={handleInputChange}
            />
            <FormLabel htmlFor="paid">Paid Internship</FormLabel>
          </FormCheckboxGroup>
          
          {formData.paid && (
            <FormInput
              type="text"
              id="salary"
              name="salary"
              value={formData.salary}
              onChange={handleInputChange}
              placeholder="e.g. $1200/month"
              required={formData.paid}
            />
          )}
        </FormGroup>
        
        <FormGroup>
          <FormLabel htmlFor="location">Location</FormLabel>
          <FormInput
            type="text"
            id="location"
            name="location"
            value={formData.location}
            onChange={handleInputChange}
            placeholder="e.g. New York, NY or Remote"
            required
          />
        </FormGroup>
        
        <FormGroup>
          <FormLabel htmlFor="skills">Required Skills</FormLabel>
          <SkillsInput>
            <FormInput
              type="text"
              id="skills-input"
              value={skillInput}
              onChange={handleSkillInputChange}
              onKeyPress={handleSkillInputKeyPress}
              placeholder="Type a skill and press Enter to add"
            />
            
            <div className="skills-container">
              {formData.skills.map((skill, index) => (
                <div key={index} className="skill-tag">
                  {skill}
                  <button
                    type="button"
                    className="remove-btn"
                    onClick={() => removeSkill(skill)}
                  >
                    <FaTimes />
                  </button>
                </div>
              ))}
            </div>
          </SkillsInput>
        </FormGroup>
        
        <FormGroup>
          <FormLabel htmlFor="description">Job Description</FormLabel>
          <FormTextarea
            id="description"
            name="description"
            value={formData.description}
            onChange={handleInputChange}
            placeholder="Provide details about the internship responsibilities and requirements..."
            required
          />
        </FormGroup>
        
        {isEdit && (
          <FormGroup>
            <FormLabel htmlFor="status">Status</FormLabel>
            <FormSelect
              id="status"
              name="status"
              value={formData.status}
              onChange={handleInputChange}
            >
              <option value="pending">Pending</option>
              <option value="active">Active</option>
              <option value="expired">Expired</option>
            </FormSelect>
          </FormGroup>
        )}
        
        <FormActions>
          <CancelButton type="button" onClick={onCancel}>
            Cancel
          </CancelButton>
          <SubmitButton type="submit">
            {isEdit ? 'Update Job Post' : 'Create Job Post'}
          </SubmitButton>
        </FormActions>
      </form>
    </ModalContainer>
  );
};

export default JobPostForm;
